<template>
  <div class="chat-container">
    <div
      v-if="!isChatOpen"
      class="btn btn-primary btn-icon chat-button disabled"
    >
      <feather-icon
        icon="MessageSquareIcon"
        size="16"
      />
    </div>
    <transition
      name="chat"
      @before-enter="beforeEnter"
      @after-leave="afterLeave"
    >
      <div
        v-if="isChatOpen"
        class="chat-window"
      >
        <div class="chatbox-header">
          <div class="advisor">
            <div class="advisor-avatar">
              <b-img
                :src="advisor.poster"
                :alt="advisor.title"
                class="rounded-circle avatar-img"
              />
            </div>
            <div class="advisor-title">
              <h4>{{ advisor.title }}</h4>
              <small class="text-muted">{{ advisor.status }}</small>
            </div>
          </div>
          <b-button
            variant="primary"
            class="btn-icon close-button"
            size="sm"
            @click="toggleChat"
          >
            <feather-icon
              icon="XIcon"
              size="16"
            />
          </b-button>
        </div>
        <div class="chatbox-chat">
          <vue-perfect-scrollbar
            ref="scrollbar"
            style="max-height: 232px"
          >
            <div
              v-for="(msg, index) in messages"
              :key="index"
              :class="{'user-msg': msg.sender === 'user', 'advisor-msg': msg.sender === 'advisor'}"
            >
              <div class="msg-text">
                {{ msg.text }}
              </div>
            </div>
          </vue-perfect-scrollbar>
        </div>
        <div class="chatbox-footer">
          <!-- button on right -->
          <b-input-group>
            <b-form-input
              v-model="newMessage"
              placeholder="Enter to send"
              @keyup.enter="sendMessage"
            />
          </b-input-group>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  BImg,
  BButton,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    BImg,
    BButton,
    BFormInput,
    BInputGroup,
    // 3rd party
    VuePerfectScrollbar
  },
  data() {
    return {
      messages: [
        // Örnek danışman mesajları
        { text: "Merhaba, size nasıl yardımcı olabilirim?", sender: 'advisor' },
        // ... diğer örnek mesajlar
      ],
      newMessage: '',
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
        wheelPropagation: false
      },
      advisor: {
        poster: require("@/assets/images/uploads/selin-ergin.jpg"),
        title: "Selin Ergin",
        status: "Offline",
      }
    };
  },
  computed: {
    isChatOpen() {
      return this.$store.state.messageBox.isChatOpen;
    }
  },
  watch: {
    messages() {
      this.scrollToBottom();
    },
  },
  mounted() {
    this.scrollToBottom();
    // API'den gelen mesajlar gibi davranan örnek mesajlar ekle
    setTimeout(() => {
      this.messages.push({ text: "Size bir konuda yardımcı olabilir miyim?", sender: 'advisor' });
      this.$nextTick(this.scrollToBottom);
    }, 12000); // 2 saniye sonra mesajı ekle
  },
  methods: {
    beforeEnter(el) {
      // Animasyon başlamadan önce scrollbar'ın overflow stilini koru
      const scrollbar = this.$refs.scrollbar;
      if (scrollbar) {
        scrollbar.$el.style.overflow = 'hidden';
      }
    },
    afterLeave(el) {
      // Animasyon bittikten sonra scrollbar'ın overflow stilini geri yükle
      const scrollbar = this.$refs.scrollbar;
      if (scrollbar) {
        scrollbar.$el.style.overflow = '';
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollbar = this.$refs.scrollbar;
        if (scrollbar) {
          scrollbar.$el.scrollTop = scrollbar.$el.scrollHeight;
        }
      });
    },
    toggleChat() {
      this.$store.commit('TOGGLE_CHAT'); // Bu product'i üst bileşene bildirin
      this.isChatOpen = !this.isChatOpen;
      if (this.isChatOpen) {
        // Pencere açıldığında, kaydırma çubuğunu aşağı kaydır
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    sendMessage() {
      if (this.newMessage.trim()) {
        this.messages.push({
          text: this.newMessage,
          sender: 'user'
        });
        this.newMessage = ''; // Input alanını temizle
        this.$nextTick(this.scrollToBottom);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-container {
  position: fixed;
  bottom: 2%;
  right: 20px;
  z-index: 999999;
}

.chat-button {
  position: fixed;
  bottom: 2%;
  right: 20px;
  z-index: 999998;
}

/* Animasyon için geçiş stilleri */
.chat-enter-active,
.chat-leave-active {
  transition: opacity 0.5s, transform 0.5s;
  transform-origin: bottom right;

  .ps{
    overflow: hidden !important;
  }
}

.chat-enter, .chat-leave-to /* 2.1.8+ versiyonları için .chat-leave-active */ {
  opacity: 0;
  transform: scale(0.1);
}

.chat-window {
  width: 300px;
  min-height: 400px;
  /* Diğer stil ayarları */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  border-radius: 0.428rem;
  border: 1px solid #5912b4;
  background: rgb(19, 5, 33);
  box-shadow: 0 0 25px 3px #100223;
}

.chat-container.open button {
  /* Açıkken buton stil ayarları */
}

.chatbox-header {
  padding: 1rem;
  position: relative;

  .close-button {
    position: absolute;
    right: -8px;
    top: -8px;
  }

  .advisor {
    display: flex;
    align-items: center;
    .advisor-avatar {
      .avatar-img{
        width: 50px;
      }
    }
    .advisor-title {
      margin-left: 1rem;
    }
    h4 {
      margin: 0;
    }
  }
}

.chatbox-chat {
  display: flex;
  flex-grow: 1;
  justify-items: flex-end;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  padding: 1rem 1rem .5rem 1rem;

  .advisor-msg {
    margin: 1.2rem 0;
    padding-left: 20%;
    .msg-text {
      display: inline-block;
      font-size: 0.9rem;
      padding: 0.6rem;
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      border-radius: 0.428rem;
    }
  }

  .user-msg {
    margin: 1.2rem 0;
    padding-right: 20%;
    .msg-text {
      display: inline-block;
      font-size: 0.9rem;
      font-weight: 500;
      padding: 0.6rem;
      background: #fff;
      color: #000;
      border-radius: 0.428rem;
    }
  }
}

.chatbox-footer {
  padding: 1rem;
}
</style>
